export default __webpack_public_path__ + "static/media/c.1f803f81.png";